import './index.less'
import classNames from "classnames";
import React from "react";
import { TabsBase, TabsTabPane } from "@/componentsUI/Tabs";

export interface TableHeaderOnly2ItemsProps {
    value?: '1' | '2' | '3',
    onChange?: (v: '1' | '2' | '3') => void,
    text1: string,
    text2: string,
    text3?: string
    className?: string
}

const TableHeaderOnly2Items = (props) => {
    const { value, onChange, text1, text2, text3, className } = props
    const prefixCls = 'table-header-only-2-items';
    const name = classNames([prefixCls, className, {
        [`${prefixCls}-hidden`]: !text1 && !text2 && !text3,
    }])
    return (<TabsBase className={`${name}`} activeTab={value} onChange={onChange}>
        {text1 && <TabsTabPane key={'1'} title={text1} >
        </TabsTabPane>}
        {text2 && <TabsTabPane key={'2'} title={text2} >
        </TabsTabPane>}
        {
            text3 && <TabsTabPane key={'3'} title={text3} >
            </TabsTabPane>
        }
    </TabsBase>)
}

export default TableHeaderOnly2Items
